"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _role = require("@/api/role");
var _settings = require("@/settings");
var _index = _interopRequireDefault(require("../index"));
// import { constantRoutes } from "@/router";

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(function (role) {
      return route.meta.roles.includes(role);
    });
  } else {
    return true;
  }
}
var state = {
  addRoutes: [],
  routes: [],
  constRoutes: []
};
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.routes = routes;
  },
  setConstRoutes: function setConstRoutes(state, value) {
    state.constRoutes = value;
  }
};
var actions = {
  setRoutesAccess: function setRoutesAccess(_ref, constantRoutes) {
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      var commit, res, routesAccess, tmpConst, _tmpConst;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.prev = 1;
              if (!_settings.checkPermission) {
                _context.next = 13;
                break;
              }
              _context.next = 5;
              return (0, _role.getPermission)(_index.default.getters.info.role.id);
            case 5:
              res = _context.sent;
              routesAccess = res.data.permissions;
              commit("SET_ROUTES", routesAccess);
              tmpConst = JSON.parse(JSON.stringify(constantRoutes));
              routesAccess.forEach(function (element) {
                var parentPath = element.path.split("/")[1];
                var childPath = element.path.split("/")[2];
                tmpConst.forEach(function (route) {
                  if (route.path == "/" + parentPath) {
                    route.access = true;
                    route.children.forEach(function (child) {
                      if (child.path == childPath) {
                        child.access = true;
                      }
                    });
                  }
                });
              });
              commit("setConstRoutes", tmpConst);
              _context.next = 15;
              break;
            case 13:
              _tmpConst = JSON.parse(JSON.stringify(constantRoutes));
              commit("setConstRoutes", _tmpConst);
            case 15:
              _context.next = 20;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](1);
              console.log('setRoutesAccess err', _context.t0);
            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 17]]);
    }))();
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;